function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getArrayOfNodes } from 'scripts/util';

/**
 * @descrpition trigger a callback based on an elements position in the viewport.
 * @param  {Element}	element			- The DOM element to track viewport status of
 * @param  {String}		className		- Optional class name to toggle on the element
 * @param  {String}		threshold		- px or % value of how far into the viewport to trigger the observer
 * @param  {Function}	onEnter			- callback when element enters threshold
 * @param  {mixed}		onExit			- callback when element leaves threshold
 *
 * @param  {Object}  options - className, threshold, onEnter, onExit, handleOnce
 *
 * @todo - find way to unobserve element after triggered once by passing onExit = true
 * switch default to true to always unobserve after triggered once
 * probably need to revert back to bbeelers methods a bit
 */
var ViewportObserver = /*#__PURE__*/function () {
  // constructor(targets, className = null, threshold = null, onEnter = null, onExit = false) {
  function ViewportObserver(targets) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    _classCallCheck(this, ViewportObserver);
    // only run once by default
    this.onExit = true;
    // get options
    Object.assign(this, options);
    this.els = getArrayOfNodes(targets);
    if (!this.els || this.els.length == 0) return;
    this.createObserver();
  }
  return _createClass(ViewportObserver, [{
    key: "createObserver",
    value: function createObserver() {
      var _this = this;
      var opts = this.threshold ? {
        rootMargin: "0px 0px -".concat(this.threshold, " 0px")
      } : null;
      var observer = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          return _this.handleIntersection(entry, observer);
        });
      }, opts);
      this.els.forEach(function (el) {
        return observer.observe(el);
      });
      // observer.observe(this.els) // expects Element
    }
  }, {
    key: "handleIntersection",
    value: function handleIntersection(entry, observer) {
      console.log(observer.takeRecords());
      if (this.className) entry.target.classList.toggle(this.className, entry.isIntersecting);
      if (this.onEnter && entry.isIntersecting) this.onEnter(entry, observer);
      if (this.onExit && !entry.isIntersecting) this.onExit(entry, observer);
      if (this.handleOnce == true && entry.isIntersecting) observer.unobserve(entry.target);

      // figure out a way to handle exit and handle once together
      // onExit doesn't really do what it sounds like right now
      // no way to track if it has already triggered.. :/
      // could attach to Node but no good way to handle multiple
      // observers if that were the case

      console.log(entry);
      console.log(observer);
    }
  }]);
}();
export { ViewportObserver as default };